export default {
  MATERIAL_SENT: 'Material versendet',
  MATERIAL_RETURNED: 'Material zurückgeschickt',
  MATERIAL_CHECKED: 'Material überprüft',
  NO_LOGISTICS: 'Keine Logistik notwendig',
  NO_STATUS: 'Kein Status',
};
